import { UserPreferences } from '../classes/user-preferences';
import { HistoryItem } from '../classes/history-item';

export class UserSchema {
  updatedByStorage?: boolean = false;
  email?: string;
  buy?: boolean;
  language?: string;
  name?: string;
  phoneNumber?: string;
  sell?: boolean;
  preferences?: UserPreferences;
  session?: UserSession;
  //** This is purposely left untyped so that MaxPerx can add whatever properties needed, without remax.ca accidentally overwriting them */
  maxPerxPreferences?: any;

  constructor(args: UserSchema = {}) {
    this.email = args.email;
    this.buy = args.buy;
    this.language = args.language;
    // The server sends back a name initially with just a space in it, thus giving it problems
    this.name = args.name ? args.name.trim() : '';
    this.phoneNumber = args.phoneNumber;
    this.sell = args.sell;
    this.preferences = args.preferences ? args.preferences : new UserPreferences();
    this.maxPerxPreferences = args.maxPerxPreferences;
    this.session = new UserSession();
  }
}

export class User extends UserSchema {
   /* Methods go here. */
  getInitials() {
    if (!this.name) return null;
    const values = this.name.split(' ');
    if (values.length >= 2) {
      return values[0].charAt(0).toUpperCase() + values[1].charAt(0).toUpperCase();
    } else {
      return values[0].charAt(0).toUpperCase();
    }
  }
}

/**
 * This class is for holding session items for a user.
 * @export
 * @class UserSession
 */
export class UserSession {
  // A list of the users history of visiting main pages. Used so the next page they go to can find out which page to go back to.
  // Start the history with a default item that will send the user back to the homepage.
  history: HistoryItem[] = [ new HistoryItem() ];

  // Start the history with a default item that will send the user back to the homepage.
  resetHistory() {
    this.history = [ new HistoryItem() ];
  }
}
